import { render, staticRenderFns } from "./CompanyStructureSideBar.vue?vue&type=template&id=6ab1cc1c"
import script from "./CompanyStructureSideBar.vue?vue&type=script&lang=js"
export * from "./CompanyStructureSideBar.vue?vue&type=script&lang=js"
import style0 from "./CompanyStructureSideBar.vue?vue&type=style&index=0&id=6ab1cc1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports